module.exports = __webpack_public_path__ + "img/43200.2a457162.jpg";